import React, { useState } from 'react';
import './Gem.css';

const Gem = ({ onReset, resetTrigger, isSimplified, isColorBlindMode }) => {
  const [selectedColor, setSelectedColor] = useState(null);
  
  const colorOptions = [
    { name: 'teal', displayHex: '#25d3f9', polygonHex: '#25d3f9', pathHex: '#27889f' },
    { name: 'green', displayHex: '#60fbb7', polygonHex: '#60fbb7', pathHex: '#3cbe85' },
    { name: 'fuchsia', displayHex: '#fe6fa5', polygonHex: '#fe6fa5', pathHex: '#8d2f4d' },
    { name: 'orange', displayHex: '#fba623', polygonHex: '#fba623', pathHex: '#be780e' },
    { name: 'purple', displayHex: '#a24efe', polygonHex: '#a24efe', pathHex: '#5e2fa2' }
  ];

    const colorSymbols = {
    'teal': '🐎', // horseshoe
    'green': '🌵', // cactus
    'fuchsia': '👢', // boot
    'orange': '⭐', // sheriff badge
    'purple': '⚒️' // hammer and pick
  };

    const cycleColor = () => {
    const currentIndex = selectedColor 
      ? colorOptions.findIndex(color => color.name === selectedColor.name)
      : -1;
    const nextIndex = (currentIndex + 1) % colorOptions.length;
    setSelectedColor(colorOptions[nextIndex]);
  };
  
  const getPolygonColor = () => {
    if (!selectedColor) return '#928b80';
    return selectedColor.polygonHex;
  };
  
  const getPathColor = () => {
    if (!selectedColor) return '#484a43';
    return selectedColor.pathHex;
  };
  
  React.useEffect(() => {
    setSelectedColor(null);
  }, [resetTrigger]);
  
  return (
    <div className="gem" style={{ position: 'relative' }}>
      {isColorBlindMode && selectedColor && (
        <div 
          style={{
            position: 'absolute', 
            top: 'calc(50% - 1.5rem)', 
            left: '50%', 
            transform: 'translateX(-50%)', 
            fontSize: '2rem',
            zIndex: 10,
            pointerEvents: 'none'
          }}
        >
          {colorSymbols[selectedColor.name]}
        </div>
      )}
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264.44 261.79" onClick={cycleColor}
        style={{ cursor: 'pointer' }}>
      {isSimplified ? (
          <circle 
            cx="132" 
            cy="130" 
            r="100" 
            fill={getPolygonColor()} 
          />
        ) : (
        <React.Fragment>
        <g id="Layer_2">
          <polygon points="74.17 5.45 184.48 5.45 258.25 100.45 217.25 206.07 175.25 255.45 89.17 255.45 38.66 193.66 5.17 103.45 74.17 5.45" style={{ fill: getPolygonColor(), stroke: getPolygonColor() }}/>
        </g>
        <g id="Layer_3">
          <g>
            <path d="M178.78,135.85c19.32-23.16,40.59-44.59,60.46-67.28l-8.54-3.54c-.16-4.99,1.04-1.32.1-1.42.06,0-2.03,1.74-.49.65l3.85-.5-.06-.02,2.99,7.34c.5-.91,1.47-1.75,2.14-2.51l-7.85-1.01c8.56,12.38,17.46,24.56,23.55,38.41l-.5-3.85c-.54,2.29-2.99,4.01-4.58,5.54-2.84,2.74-5.67,5.49-8.48,8.25-5.56,5.46-11.08,10.97-16.58,16.5-10.9,10.97-21.7,22.03-32.59,33-2.29,2.31-5.54,4.62-6.77,7.71-1.35,3.38-1.48,7.97-2.14,11.57l-4.29,23.14c-2.86,15.43-5.71,30.86-8.57,46.29-1.16,6.29,8.47,8.99,9.64,2.66,3.69-19.93,7.38-39.86,11.07-59.79.95-5.14,1.9-10.29,2.86-15.43.53-2.85.71-4.16,2.53-6.33,1.64-1.95,3.67-3.69,5.46-5.5,7.02-7.09,14.01-14.21,21.02-21.31s14.11-14.26,21.24-21.31c3.73-3.69,7.47-7.36,11.24-11,2.63-2.54,5.4-4.91,7.23-8.13,3.9-6.87-3.12-15.62-6.65-21.51-4.94-8.25-10.6-16.05-16.07-23.95-1.72-2.48-5.57-3.59-7.85-1.01-1.24,1.4-2.79,2.88-3.7,4.53-1.67,3.04-.05,6.19,2.99,7.34,4.02,1.53,9.37-4.64,9.25-8.34-.13-4.06-5.55-6.95-8.54-3.54-19.87,22.68-41.13,44.12-60.46,67.28-4.1,4.91,2.94,12.02,7.07,7.07h0Z" style={{ fill: getPathColor(), stroke: getPathColor() }}/>
            <path d="M90.53,260.45c16.48.8,32.99,1.26,49.49,1.33,10.67.04,21.43.05,32.06-.97,2.88-.28,5.19-.34,7.31-2.53,3.23-3.34,6.08-7.17,9.1-10.7,6.16-7.19,12.36-14.35,18.51-21.56,6.21-7.28,12.37-14.6,18.38-22.04s8.21-16.55,11.49-25.01c6.92-17.84,13.64-35.75,20.46-53.62,1.64-4.31,3.29-8.62,4.95-12.93s3.17-7.81,1.26-12.4c-1.61-3.87-4.45-7.32-6.76-10.81-2.57-3.88-5.13-7.76-7.7-11.63-10.05-15.16-20.24-30.24-31.26-44.72-5.77-7.57-11.68-14.97-17.65-22.38-2.29-2.85-4.88-8.73-8.59-9.85-4.34-1.3-10.56-.18-15.08-.18-22.15-.01-44.31-.08-66.46-.41-6.44-.09-6.44,9.91,0,10,26.74.39,53.48.41,80.21.41l-4.32-2.48c4.66,6.84,10.11,13.04,15.29,19.47,5.8,7.19,11.25,14.72,16.65,22.22,10.87,15.09,21.04,30.67,31.31,46.17,1.21,1.83,2.64,3.62,3.68,5.54,1.42,2.63,1.55,3.76.48,6.53-1.9,4.92-3.79,9.85-5.67,14.78-3.48,9.13-6.94,18.27-10.41,27.4s-6.89,18.1-10.4,27.12c-1.75,4.51-3.51,9.01-5.3,13.51-1.88,4.75-4.89,8.21-8.12,12.13-13.66,16.57-27.9,32.65-41.74,49.06l3.54-1.46c-16.81,2.11-34.09,1.47-50.98,1.12-11.25-.23-22.5-.58-33.74-1.12-6.43-.31-6.42,9.69,0,10h0Z" style={{ fill: getPathColor(), stroke: getPathColor() }}/>
            <path d="M80.36,179.26c36.59.25,73.19.25,109.78,0,2.92-.02,6.09-3.23,4.82-6.33-1.13-2.77-2.47-5.91-5.62-6.85-2.56-.76-5.32.24-6.71,2.55-3.38,5.65,2.41,10.17,7.51,10.63,3.35.3,5.55-3.43,4.82-6.33-1.95-7.79-4.62-15.41-7.53-22.88-2.6-6.68-4.79-13.63-7.85-20.12-.73-1.55-2.68-2.48-4.32-2.48-28.69,0-57.39.03-86.08-.13-6.44-.04-6.44,9.96,0,10,28.69.16,57.39.13,86.08.13l-4.32-2.48c2.95,6.25,5.03,13.12,7.53,19.57,2.66,6.87,5.05,13.89,6.84,21.04l4.82-6.33-4.82,6.33,4.82-6.33c-36.59.25-73.19.25-109.78,0-6.44-.04-6.44,9.96,0,10h0Z" style={{ fill: getPathColor(), stroke: getPathColor() }}/>
            <path d="M92.72,128.78c-19.32-23.16-40.59-44.59-60.46-67.28-2.99-3.41-8.41-.54-8.54,3.54-.12,3.71,5.24,9.86,9.25,8.34,3.04-1.15,4.66-4.31,2.99-7.34-.91-1.65-2.47-3.15-3.7-4.53-2.29-2.57-6.14-1.47-7.85,1.01-5.47,7.91-11.13,15.7-16.07,23.95-3.33,5.57-10.39,14.44-6.93,21.02,1.82,3.45,4.76,5.95,7.52,8.62,3.77,3.64,7.52,7.31,11.24,11,7.13,7.05,14.19,14.17,21.24,21.31,7.01,7.1,14,14.22,21.02,21.31,1.8,1.81,3.82,3.55,5.46,5.5,1.82,2.17,2,3.48,2.53,6.33l2.68,14.46c3.75,20.25,7.5,40.5,11.25,60.75,1.17,6.32,10.81,3.64,9.64-2.66l-8.57-46.29-4.29-23.14c-.68-3.68-.81-8.09-2.14-11.57-1.19-3.11-4.46-5.38-6.77-7.71-10.9-10.97-21.7-22.03-32.59-33-5.26-5.3-10.55-10.58-15.88-15.81-2.81-2.76-5.63-5.51-8.47-8.25-1.73-1.66-4.69-3.69-5.29-6.23l-.5,3.85c6.09-13.85,14.99-26.03,23.55-38.41l-7.85,1.01c.67.75,1.64,1.6,2.14,2.51l2.99-7.34-.06.02,3.85.5c1.54,1.09-.55-.64-.49-.65-.94.1.26-3.56.1,1.42l-8.54,3.54c19.87,22.68,41.13,44.12,60.46,67.28,4.13,4.95,11.17-2.16,7.07-7.07h0Z" style={{ fill: getPathColor(), stroke: getPathColor() }}/>
            <path d="M109.07.04c-5.89.09-11.78.23-17.67.36s-11.71-.79-17.22.05c-4.87.74-7.56,7.11-10.44,10.68-3.62,4.48-7.37,8.85-10.89,13.41-7.66,9.95-15.09,20.11-22.24,30.43s-13.66,20.18-20.38,30.34c-3.18,4.8-7.69,9.85-9.59,15.32-2.01,5.77,1.24,11.08,3.29,16.43,9.53,24.84,18.79,49.78,28.57,74.53,1.25,3.17,2.26,6.59,4.15,9.41,1.76,2.63,4.04,5.01,6.04,7.46,4.85,5.91,9.78,11.76,14.75,17.58,9.39,11,18.89,21.91,28.21,32.97,4.15,4.93,11.2-2.18,7.07-7.07-12.2-14.46-24.7-28.66-36.84-43.17-3.08-3.67-6.13-7.37-9.14-11.09s-4.54-8.6-6.36-13.23c-3.53-9.01-7-18.04-10.45-27.08s-6.92-18.21-10.38-27.31c-1.75-4.6-3.5-9.2-5.26-13.79-1.57-4.1-5.35-9.97-3.25-14.06,4.17-8.13,10.43-15.76,15.49-23.37s10.43-15.57,15.83-23.24c5.82-8.27,11.86-16.4,17.97-24.45s12.64-15.01,18.18-23.14l-4.32,2.48c11.64,0,23.25-.23,34.89-.41,6.43-.1,6.45-10.1,0-10h0Z" style={{ fill: getPathColor(), stroke: getPathColor() }}/>
            <path d="M84.86,129.93c-3.06,6.49-5.25,13.44-7.85,20.12-2.91,7.48-5.58,15.1-7.53,22.88-.73,2.9,1.48,6.63,4.82,6.33,5.09-.46,10.89-4.98,7.51-10.63-1.38-2.31-4.15-3.31-6.71-2.55-3.15.94-4.49,4.08-5.62,6.85-2.44,5.95,7.23,8.54,9.64,2.66l-4.82-6.33,4.82,6.33c1.79-7.15,4.18-14.16,6.84-21.04,2.5-6.46,4.58-13.32,7.53-19.57,2.73-5.79-5.89-10.87-8.63-5.05h0Z" style={{ fill: getPathColor(), stroke: getPathColor() }}/>
          </g>
        </g>
        </React.Fragment>
        )}
      </svg>
      {!isSimplified && (
      <div className="color-options">
        {colorOptions.map((option, index) => (
          <div
            key={index}
            className="color-option"
            style={{ 
              backgroundColor: option.displayHex, 
              borderColor: option.pathHex  }}
            onClick={() => setSelectedColor(option)}
          />
        ))}
      </div>
       )}
    </div>
  );
};

export default Gem;